import React from 'react';
import PropTypes from 'prop-types';
import { mapObject, constant } from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { IconButton } from '@bingads-webui-react/fabric-control';
import { getTagStyle } from '../../style/js/tag';

const TagComponent = (props) => {
  const {
    classes,
    text,
    onRemove,
  } = props;
  return (
    <div className={classes.root}>
      <span className="text">{text}</span>
      { onRemove && <IconButton iconProps={{ iconName: 'Cancel' }} onClick={onRemove} />}
    </div>);
};

TagComponent.propTypes = {
  text: PropTypes.string.isRequired,
  onRemove: PropTypes.func,
  classes: PropTypes.shape(mapObject(
    getTagStyle(),
    constant(PropTypes.string.isRequired)
  )).isRequired,
};

TagComponent.defaultProps = {
  onRemove: null,
};

export const Tag = withDefaultStyles(TagComponent, getTagStyle);

